module.exports = __webpack_public_path__ + "static/media/photo280.fb9291c6.jpg";